// src/components/Button/Button.tsx
import React from 'react';
import './Button.css';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
}

const Button: React.FC<ButtonProps> = ({ children, onClick, variant = 'primary' }) => {
  const className = `btn ${variant === 'primary' ? 'btn-primary' : 'btn-secondary'}`;
  
  return (
    <button className={className} onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;